import React from 'react';
import loadable from '@loadable/component';
import { LoadingPage } from 'components/core/LoadingPage';

const options = {
	fallback: <LoadingPage />,
};

// Component Bundles
export { ExperimentModal } from 'components/experiment/ExperimentModal';

// Page Bundles
export const HomePage = loadable(
	() => import(/* webpackChunkName: "HomePage" */ './HomePage/HomePage'),
	options,
);
export const ContactPageV2 = loadable(
	() =>
		import(
			/* webpackChunkName: "ContactPageV2" */ './ContactPageV2/ContactPageV2'
		),
	options,
);
export const SearchPage = loadable(
	() =>
		import(/* webpackChunkName: "SearchPage" */ './SearchPage/SearchPage'),
	options,
);
export const FacilityPage = loadable(
	() =>
		import(
			/* webpackChunkName: "FacilityPage" */ './FacilityPage/FacilityPage'
		),
	options,
);
export const FacilityPageV2 = loadable(
	() =>
		import(
			/* webpackChunkName: "FacilityPageV2" */ './FacilityPageV2/FacilityPageV2'
		),
	options,
);
export const UnitPage = loadable(
	() => import(/* webpackChunkName: "UnitPage" */ './UnitPage/UnitPage'),
	options,
);
export const UnitPageV2 = loadable(
	() =>
		import(/* webpackChunkName: "UnitPageV2" */ './UnitPageV2/UnitPageV2'),
	options,
);
export const ConfirmationPage = loadable(
	() =>
		import(
			/* webpackChunkName: "ConfirmationPage" */ './ConfirmationPage/ConfirmationPage'
		),
	options,
);
export const LegalPage = loadable(
	() => import(/* webpackChunkName: "LegalPage" */ './LegalPage/LegalPage'),
	options,
);

export const PrivacyPolicyPage = loadable(
	() =>
		import(
			/* webpackChunkName: "PrivacyPolicyPage" */ './PrivacyPolicyPage/PrivacyPolicyPage'
		),
	options,
);
export const LegalReviewPage = loadable(
	() =>
		import(
			/* webpackChunkName: "LegalReviewPage" */ './LegalPage/LegalReviewPage'
		),
	options,
);
export const StatePage = loadable(
	() => import(/* webpackChunkName: "StatePage" */ './StatePage/StatePage'),
	options,
);
export const MoveInConfirmationPage = loadable(
	() =>
		import(
			/* webpackChunkName: "MoveInConfirmationPage" */ './MoveInConfirmationPage/MoveInConfirmationPage'
		),
	options,
);
export const StorageBasicsPage = loadable(
	() =>
		import(
			/* webpackChunkName: "StorageBasicsPage" */ './StorageBasicsPage/StorageBasicsPage'
		),
	options,
);
export const SizeGuidePage = loadable(
	() =>
		import(
			/* webpackChunkName: "SizeGuidePage" */ './SizeGuidePage/SizeGuidePage'
		),
	options,
);
export const StyleGuide = loadable(
	() =>
		import(/* webpackChunkName: "StyleGuide" */ './StyleGuide/StyleGuide'),
	options,
);
export const StyleGuidePage = loadable(
	() =>
		import(
			/* webpackChunkName: "StyleGuidePage" */ './StyleGuidePage/StyleGuidePage'
		),
	options,
);
export const VehicleStoragePage = loadable(
	() =>
		import(
			/* webpackChunkName: "VehicleStoragePage" */ './VehicleStoragePage/VehicleStoragePage'
		),
	options,
);
export const StorageNearMePage = loadable(
	() =>
		import(
			/* webpackChunkName: "StorageNearMePage" */ './StorageNearMePage/StorageNearMePage'
		),
	options,
);
export const ClimateControlledPage = loadable(
	() =>
		import(
			/* webpackChunkName: "ClimateControlledPage" */ './ClimateControlledPage/ClimateControlledPage'
		),
	options,
);
export const PSPPage = loadable(
	() => import(/* webpackChunkName: "PSPPage" */ './PSPPage/PSPPage'),
	options,
);
export const UnsubscribePage = loadable(
	() =>
		import(
			/* webpackChunkName: "UnsubscribePage" */ './UnsubscribePage/UnsubscribePage'
		),
	options,
);
export const ContactPage = loadable(
	() =>
		import(
			/* webpackChunkName: "ContactPage" */ './ContactPage/ContactPage'
		),
	options,
);
export const EmailAuthPage = loadable(
	() =>
		import(
			/* webpackChunkName: "EmailAuthPage" */ './EmailAuthPage/EmailAuthPage'
		),
	options,
);

export const PaidLandingPage = loadable(
	() =>
		import(
			/* webpackChunkName: "PaidLandingPage" */ './PaidLandingPage/PaidLandingPage'
		),
	options,
);

export const SearchPageWrapper = loadable(
	() =>
		import(
			/* webpackChunkName: "SearchPageWrapper" */ './SearchPage/SearchPageWrapper'
		),
	options,
);

export const OMIPage = loadable(
	() => import(/* webpackChunkName: "OMIPage" */ './OMIPage/OMIPage'),
	options,
);
